import React from 'react';
import { View, Text, StyleSheet } from '@react-pdf/renderer';
import { StandardTitle } from './StandardTitle';

const styles = StyleSheet.create({
    container: {
        marginBottom: 15,
    },
    palletVariantHeader: {
        fontSize: 14,
        color: '#333',
        fontWeight: 'bold',
        marginTop: 15,
        marginBottom: 10,
    },
    table: {
        display: 'flex',
        width: '100%',
        marginBottom: 20,
        borderWidth: 1,
        borderColor: '#e0e0e0',
        borderRadius: 4,
        overflow: 'hidden',
    },
    tableHeader: {
        flexDirection: 'row',
        backgroundColor: '#f0f5ff',
        borderBottomWidth: 1,
        borderBottomColor: '#e0e0e0',
    },
    tableRow: {
        flexDirection: 'row',
        borderBottomWidth: 1,
        borderBottomColor: '#e0e0e0',
        minHeight: 30,
        alignItems: 'center',
    },
    lastRow: {
        borderBottomWidth: 0,
    },
    tableHeaderCell: {
        padding: 8,
        textAlign: 'left',
        fontSize: 10,
        fontWeight: 'bold',
        color: '#004899',
        flex: 1,
        borderRightWidth: 1,
        borderRightColor: '#e0e0e0',
    },
    tableCell: {
        padding: 8,
        textAlign: 'left',
        fontSize: 10,
        color: '#333',
        flex: 1,
        borderRightWidth: 1,
        borderRightColor: '#e0e0e0',
    },
    numberCell: {
        backgroundColor: '#f9fafb',
        fontWeight: 'bold',
    },
    lastCell: {
        borderRightWidth: 0,
    },
    noDataText: {
        fontSize: 10,
        color: '#666',
        fontStyle: 'italic',
        padding: 10,
        textAlign: 'center',
    },
});

interface LpnSectionProps {
    pallets: Array<any>;
}

export const LpnSection: React.FC<LpnSectionProps> = ({ pallets }) => {
    // Format the RQL state value
    // const formatRqlState = (rqlState: string): string => {
    //     if (!rqlState) return 'N/A';
    //     return rqlState.toLowerCase() === 'yes' ? 'Yes' : 'No';
    // };
    console.log(pallets, 'pallets-pdf')
    return (
        <View style={styles.container}>
            {pallets.map((pallet, palletIndex) => (
                <View key={`pallet-lpn-${palletIndex}`}>
                    <StandardTitle title={`Pallet Identifiers for ${pallet.variant} - ${pallet.name}`} />

                    {pallet.lpnNumbers && pallet.lpnNumbers.length > 0 ? (
                        <View style={styles.table}>
                            {/* Table Header */}
                            <View style={styles.tableHeader}>
                                <Text style={styles.tableHeaderCell}>Pallet Number</Text>
                                <Text style={styles.tableHeaderCell}>Pallet Identifier</Text>
                                <Text style={styles.tableHeaderCell}>End Status</Text>
                                <Text style={[styles.tableHeaderCell, styles.lastCell]}>RQL State (yes or no)</Text>
                            </View>

                            {/* Table Rows */}
                            {pallet.lpnNumbers.map((lpn, index) => (
                                <View
                                    key={`lpn-${index}`}
                                    style={[
                                        styles.tableRow,
                                        index === pallet.lpnNumbers.length - 1 ? styles.lastRow : {}
                                    ]}
                                >
                                    <Text style={[styles.tableCell, styles.numberCell]}>{index + 1}</Text>
                                    <Text style={styles.tableCell}>{lpn.lpnNo || 'N/A'}</Text>
                                    <Text style={styles.tableCell}>{lpn.endStatus || lpn.endStatusPallet || 'N/A'}</Text>
                                    <Text style={[styles.tableCell, styles.lastCell]}>
                                        {lpn.rqlState}
                                    </Text>
                                </View>
                            ))}
                        </View>
                    ) : (
                        <Text style={styles.noDataText}>No LPN data available for this pallet</Text>
                    )}
                </View>
            ))}

            {pallets.length === 0 && (
                <Text style={styles.noDataText}>No pallets available</Text>
            )}
        </View>
    );
}; 